import { Component, ViewChild, OnDestroy } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';

@Component({
  selector: 'lfwms-search-criteria-cell-editor',
  templateUrl: './search-criteria-cell-editor.component.html',
  styleUrls: ['./search-criteria-cell-editor.component.css']
})
export class SearchCriteriaCellEditorComponent implements ICellEditorAngularComp, OnDestroy {

  public params: any;
  public isLoading: boolean = true;

  @ViewChild('primeFocus')
  private primeFocus;

  constructor(private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {}

  private setPrimeFocus() {
    this.primeFocus.nativeElement.focus();
  }

  public agInit(params: any): void {
    this.params = params;
    this.params.eGridCell
      .addEventListener('focus', () => this.setPrimeFocus());
    this.params.eGridCell
      .addEventListener('keyup', ($event: any) => {
        if ($event.keyCode === 13) {
          this.save();
        }
      });
    this.isLoading = false;
  }

  public afterGuiAttached() {
    if (this.params.cellStartedEdit) {
      this.setPrimeFocus();
    }
  }

  public refresh(): boolean {
    return true;
  }

  public isPopup(): boolean {
    return false;
  }

  public getValue() {
    /* Note :: params.value is passed as an Object Reference.
      Hence, value getter should return the same and NOT just params.value.cVal */
    return this.params.value;
  }

  public focusIn() {
    // Below change is done to avoid partial focus on multiple cells
    this.params.eGridCell.focus();
  }

  public focusOut() {
    this.cancel();
  }

  public ngOnDestroy() {
    this.params.eGridCell.removeEventListener('focus', () => { });
  }

  public save() {
    this.switchToViewMode();
    this.sharedServiceRegistry.savedSearchService
      .saveSearchCriteria(this.params.value.cVal,
        this.params.node.data.searchId.cVal,
        this.params.node.data.tableId.cVal,
        this.params.context.componentParent.searchService)
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200) {
            this.sharedServiceRegistry.alertService.clearAll();
            this.sharedServiceRegistry.alertService
              .success(this.coreServiceRegistry.resourceService
                .translateServerResponse(resp.statusMessage));
            this.params.context.componentParent.searchService.performSearch();
          }
        }
      });
  }

  private switchToViewMode() {
    const targetCell: any = {
      colKey: this.params.column.colId,
      rowIndex: this.params.rowIndex
    };
    this.params.context.componentParent.targetCell = targetCell;
    this.params.context.componentParent.searchService.displayMode = 'V';
  }

  public cancel() {
    this.params.value.cVal = this.params.value.cValPrev;
    this.switchToViewMode();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/search-criteria-popup/search-criteria-cell-editor/search-criteria-cell-editor.component.ts